module.exports = __webpack_public_path__ + "static/assets/1fa97d83436161d77799d4a0994ea010.svg";